'use client';

import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import AppLogo from '@/components/ui/AppLogo';
import { Menu, X, Radio, Flame, Send, UserPlus } from 'lucide-react';
import Icon from '@/components/ui/AppIcon';


const navLinks = [
  { href: '/', label: 'Inicio', icon: Flame },
  { href: '/live-stream-screen', label: 'En Vivo', icon: Radio },
  { href: '/home-landing-screen#votar', label: 'Votar', icon: Flame },
  { href: '/submit-gossip', label: 'Enviar Chisme', icon: Send },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const pathname = usePathname();

  return (
    <header className="sticky top-0 z-50 bg-card/95 backdrop-blur-md border-b border-border shadow-sm">
      <div className="max-w-screen-2xl mx-auto px-4 lg:px-8 xl:px-10 2xl:px-16 h-16 flex items-center justify-between gap-4">
        {/* Logo */}
        <Link href="/" className="flex items-center gap-2 shrink-0">
          <AppLogo size={36} />
          <span className="font-extrabold text-xl tracking-tight text-foreground hidden sm:block">
            Chisme<span className="text-primary">y</span>Tejidos
          </span>
        </Link>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks?.map((link) => {
            const isActive = pathname === link?.href;
            return (
              <Link
                key={`nav-${link?.label}`}
                href={link?.href}
                className={`nav-link px-4 py-2 rounded-full font-medium text-sm transition-all duration-150 ${
                  isActive
                    ? 'bg-primary/10 text-primary' :'text-muted-foreground hover:text-primary hover:bg-primary/5'
                }`}
              >
                {link?.label}
              </Link>
            );
          })}
        </nav>

        {/* Right Actions */}
        <div className="flex items-center gap-3">
          {/* EN VIVO badge */}
          <Link
            href="/live-stream-screen"
            className="hidden sm:flex items-center gap-1.5 bg-red-500 text-white text-xs font-bold px-3 py-1.5 rounded-full live-pulse"
          >
            <span className="w-1.5 h-1.5 bg-white rounded-full dot-pulse" />
            EN VIVO
          </Link>

          <Link
            href="/sign-up-login-screen"
            className="hidden md:flex items-center gap-2 btn-primary px-4 py-2 rounded-full text-sm font-semibold"
          >
            <UserPlus size={15} />
            Seguir el Canal
          </Link>

          {/* Mobile hamburger */}
          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="md:hidden p-2 rounded-lg text-muted-foreground hover:text-primary hover:bg-muted transition-colors"
            aria-label="Abrir menú"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>
      {/* Mobile Drawer */}
      {mobileOpen && (
        <div className="md:hidden border-t border-border bg-card px-4 py-4 flex flex-col gap-2">
          {navLinks?.map((link) => {
            const Icon = link?.icon;
            const isActive = pathname === link?.href;
            return (
              <Link
                key={`mobile-nav-${link?.label}`}
                href={link?.href}
                onClick={() => setMobileOpen(false)}
                className={`flex items-center gap-3 px-4 py-3 rounded-xl font-medium text-sm transition-all ${
                  isActive
                    ? 'bg-primary/10 text-primary' :'text-muted-foreground hover:bg-muted hover:text-primary'
                }`}
              >
                <Icon size={18} />
                {link?.label}
              </Link>
            );
          })}
          <div className="pt-2 border-t border-border">
            <Link
              href="/sign-up-login-screen"
              onClick={() => setMobileOpen(false)}
              className="flex items-center justify-center gap-2 btn-primary w-full py-3 rounded-xl text-sm font-semibold"
            >
              <UserPlus size={16} />
              Seguir el Canal 🧶
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}